import React from 'react';
import { CollapsibleSection } from '../common/CollapsibleSection';
import { PersonalParameters } from './PersonalParameters';
import { PersonData, PersonalParameterDefinition } from '../../types';

interface PersonalParametersSectionProps {
  people: PersonData[];
  personalParameters: PersonalParameterDefinition[];
  onPersonChange: (personId: string, field: string, value: any) => void;
  onPersonDelete: (personId: string) => void;
  onPersonAdd: () => void;
  onCareerChange: (personId: string, careerId: string, field: string, value: any) => void;
  onCareerDelete: (personId: string, careerId: string) => void;
  onCareerAdd: (personId: string) => void;
  simStartDate: string;
  disabled?: boolean;
}

/**
 * Personal parameters section component that wraps PersonalParameters in a collapsible section
 */
export const PersonalParametersSection: React.FC<PersonalParametersSectionProps> = ({
  people,
  personalParameters,
  onPersonChange,
  onPersonDelete,
  onPersonAdd,
  onCareerChange,
  onCareerDelete,
  onCareerAdd,
  simStartDate,
  disabled = false
}) => {
  return (
    <CollapsibleSection
      title="Personal Assumptions"
      className="personal-assumptions-section"
    >
      <div className="personal-assumptions-content">
        <PersonalParameters
          people={people}
          personalParameters={personalParameters}
          onPersonChange={onPersonChange}
          onPersonDelete={onPersonDelete}
          onPersonAdd={onPersonAdd}
          onCareerChange={onCareerChange}
          onCareerDelete={onCareerDelete}
          onCareerAdd={onCareerAdd}
          simStartDate={simStartDate}
          disabled={disabled}
        />
      </div>
    </CollapsibleSection>
  );
};
